import { Schema } from '@formily/react';
export const mergeItems = (schema, properties) => {
    schema.items = new Schema({
        type: 'object',
        properties: {
            ...(schema?.items?.properties || {}),
            ...properties,
        },
    });
    return schema;
};
export const mergeProperties = (schema, properties) => {
    schema.setProperties({
        ...properties,
        ...(schema.properties || {}),
    });
    return schema;
};
export const reactNode2VoidSchema = (children, componentsNameMap = new Set()) => {
    const result = {};
    if (!children)
        return [result, componentsNameMap, null];
    const componentName = children.props.__component_name;
    if (!componentName) {
        console.error(`can't find component name`, children.props);
        return [result, componentsNameMap, null];
    }
    componentsNameMap.add(componentName);
    const name = children.props.__id;
    const fieldSchema = {
        [name]: {
            type: 'void',
            'x-component': componentName,
            'x-compile-omitted': ['x-component-props'],
            'x-component-props': {
                ...children.props,
                __origin_child: children.props.children,
            },
        },
    };
    return [fieldSchema, componentsNameMap, name];
};
export const reactNode2Schema = (children, componentsNameMap = new Set(), targetComponents) => {
    let schema = {};
    const schemaList = [];
    if (typeof targetComponents === 'string') {
        targetComponents = [targetComponents];
    }
    if (!children)
        return [schema, componentsNameMap];
    for (let i = 0; i < children.length; i++) {
        if (targetComponents && !targetComponents.includes(children[i]?.props?.__component_name)) {
            return;
        }
        const [fieldSchema] = reactNode2VoidSchema(children[i], componentsNameMap);
        schema = {
            ...schema,
            ...fieldSchema,
        };
        schemaList.push(fieldSchema);
    }
    return {
        schema,
        schemaList,
        componentsNameMap,
    };
};
export const reactNode2SchemaV2 = (children, targetComponents) => {
    if (typeof targetComponents === 'string') {
        targetComponents = [targetComponents];
    }
    return (children || []).reduce((prev, child) => {
        if (targetComponents && !targetComponents.includes(child?.props?.__component_name)) {
            return prev;
        }
        else {
            const [outerSchema, , id] = reactNode2VoidSchema(child);
            const innerSchema = outerSchema[id];
            prev.innerSchemaMap.set(id, innerSchema);
            prev.innerSchemaMap.set(innerSchema, id);
            Object.assign(prev.innerSchema, {
                [id]: innerSchema,
            });
            Object.assign(prev.outerSchema, {
                ...outerSchema,
            });
            return {
                outerSchema: prev.outerSchema,
                outerSchemas: prev.outerSchemas.concat(outerSchema),
                innerSchema: prev.innerSchema,
                innerSchemas: prev.innerSchemas.concat(innerSchema),
                innerSchemaMap: prev.innerSchemaMap,
            };
        }
    }, {
        outerSchema: {},
        outerSchemas: [],
        innerSchema: {},
        innerSchemas: [],
        innerSchemaMap: new Map(),
    });
};
export const getComponentNamesSet = (children, depth = 1, set = new Set()) => {
    if (depth === 0)
        return set;
    for (let i = 0; i < children.length; i++) {
        const child = children[i];
        const componentName = child.props.__component_name;
        if (componentName) {
            set.add(componentName);
        }
        getComponentNamesSet(child?.props.children ?? [], depth - 1, set);
    }
    return set;
};
